export default "__VITE_ASSET__P8Y4ed_6__"